module.exports = __webpack_public_path__ + "static/media/preferncewhite.ec4ffc36.svg";